{
    "message": {
        "name": "Name",
        "hour": "Hour",
        "day": "Day",
        "month": "Month",
        "year": "Year",
        "show": "Show",
        "liters": "liters",
        "price_estimate": "price estimate",
        "edit": "Edit",
        "move_up": "Move up",
        "move_down": "Move down",
        "edit_order": "Edit order",
        "finish_ordering": "Finish ordering",
        "notes": "Notes (coming soon)",
        "alarms": "Alarms",
        "sharing": "Sharing",
        "remove": "Remove",
        "confirm_remove_object": "Are you sure you want to remove this object?",
        "confirm_remove_homebase": "Are you sure you want to remove this homebase?",
        "confirm_remove_prefix": "Are you sure you want to remove",
        "postfix_building": "building",
        "postfix_unit": "apartment/office",
        "postfix_transmitter": "transmitter",
        "postfix_validation_transmitter": "validation transmitter",
        "confirm_remove_transmitter": "Are you sure you really want to remove the transmitter?",
        "confirm_remove_transmitter_billing": "Removing it may distort data used for billing.",
        "confirm_remove_transmitter_unused": "Never remove unused but previously active transmitters.",
        "confirm_remove_transmitter_mistake": "Remove, the transmitter was added by mistake",
        "cold_water": "Cold water",
        "hot_water": "Hot water",
        "cold_and_hot_water": "Cold and hot water",
        "total_water": "Total water",
        "add_building": "Add building",
        "edit_building": "Edit building",
        "cancel": "Cancel",
        "loading": "Loading…",
        "no_records": "No records",
        "create": "Create",
        "street": "Street",
        "house_number": "House number",
        "city": "City",
        "zip": "ZIP",
        "country": "Country",
        "price_estimate_cold_water": "Price of 1 litre of cold water",
        "price_estimate_hot_water": "Price of 1 litre of hot water",
        "price_estimate_power": "Price of 1 kWh",
        "price_estimate_heat": "Price per unit",
        "price_estimate_water": "Price of 1 litre of water",
        "from_parent_object": "From parent object",
        "price_unit": "EUR / liter",
        "save": "Save",
        "add_homebase": "Add homebase",
        "building": "Building",
        "serial_number": "Serial number",
        "add_transmitter": "Add transmitter",
        "edit_transmitter": "Edit transmitter",
        "transmitter": "Transmitter",
        "transmitters": "Transmitters",
        "transmitter_name_placeholder": "eg. bathroom",
        "unit": "Apartment/office",
        "water_meter": "Water meter",
        "not_used": "is not used",
        "correction": "Initial water meter reading (correction)",
        "correction_watter": "Initial water meter reading (correction) l",
        "correction_power": "Initial electricity meter reading (correction) kWh",
        "correction_gas": "Initial gas meter reading (correction) l",
        "correction_heat": "Initial heat meter reading (correction)",
        "koeficient_polohy": "Position coefficient",
        "koeficient_svetove_strany": "World side coefficient",
        "type": "Type",
        "add_validation_transmitter": "Add validation transmitter",
        "validation_transmitter_explanation": "Validation transmitter is a transmitter connected to validation water meter. <a href='https://chytrevodomery.cz/jak-to-funguje/kontrolni-vodomery' target='_blank'>More information</a>",
        "whole_building": "-- Whole building --",
        "whole_organization": "-- Whole organization --",
        "add_unit": "Add apartment/office",
        "edit_unit": "Edit apartment/office",
        "unit_name_placeholder": "eg. apartment 14",
        "floor": "Floor",
        "edit_organization": "Edit organization",
        "company_id": "Company ID",
        "dashboard": "Dashboard",
        "split_bill": "Split bill",
        "logout": "Log out",
        "active_devices_services": "Active devices and services",
        "prepaid_transmitters": "Prepaid transmitters",
        "increase_limit": "Increase limit",
        "active_transmitters": "Active transmitters",
        "out_of_which_validation": "out of which validation transmitters ",
        "dashboard_transmitters": "Transmitter Overview",
        "dashboard_watermeters": "Water Meters Overview",
        "dashboard_electricitymeters": "Electricity Meters Overview",
        "dashboard_gasmeters": "Gas Meters Overview",
        "dashboard_heatmeters": "Heat Meters Overview",
        "active_homebases": "Active homebases",
        "dashboard_homebases": "List of homebases",
        "homebases": "Homebases",
        "increase_transmitter_limit": "Increase limit of transmitters",
        "increase_transmitter_limit_explanation": "<p>For increasing the limit of transmitters, please contact us at <a href='michal.hudecek@bonega.cz'>michal.hudecek@bonega.cz</a>.</p>",
        "count": "Count",
        "last_data": "Last data",
        "first_data": "First data",
        "active": "Active",
        "inactive": "Inactive",
        "coming_soon": "Coming soon",
        "login": "Log in",
        "signup": "Sign up",
        "email": "Email",
        "password": "Password",
        "show_password": "Show password",
        "remember": "Remember me",
        "first_time": "First time here?",
        "signup_link": "Sign up now",
        "signup_heading": "Create new account",
        "password_repeat": "Repeat password",
        "close": "Close",
        "name_required": "Name is required.",
        "welcome_in_app": "Welcome to the Water Admin app",
        "welcome_in_app_paragraph": "Start by creating a new organization. All information below can be changed later.",
        "organization_name": "Organization Name",
        "logged_out": "Log out successful",
        "log_in_different_account": "Log in with different account",
        "ok": "OK",
        "invite": "Invite",
        "registered": "Registered",
        "unregistered": "Unregistered",
        "resend_invitation": "Invite again",
        "dashboard_share": "Sharing",
        "timezone": "Timezone",
        "sharing_people": "Following people have access to data from <b>{object}</b>:",
        "sharing_explanation": "Give access to water consumption charts for <b>{object}</b> to other people. They won't be able to change prices or other settings.",
        "email_invite_placeholder": "Enter email address",
        "personal_data_processing": "Info on personal data processing",
        "personal_data_link": "http://www.bonega.cz/firma/GDPR_BONEGA_zakaznici.pdf",
        "yes": "Yes",
        "no": "No",
        "field_is_required": "This field is required!",
        "invalid_format": "Invalid format!",
        "number_too_small": "The number is too small! Minimum: {0}",
        "number_too_big": "The number is too big! Maximum: {0}",
        "invalid_number": "Invalid number",
        "invalid_integer": "The value is not an integer",
        "text_too_small": "The length of text is too small! Current: {0}, Minimum: {1}",
        "text_too_big": "The length of text is too big! Current: {0}, Maximum: {1}",
        "this_not_text": "This is not a text!",
        "this_not_array": "This is not an array!",
        "select_min_items": "Select minimum {0} items!",
        "select_max_items": "Select maximum {0} items!",
        "invalid_date": "Invalid date!",
        "date_is_early": "The date is too early! Current: {0}, Minimum: {1}",
        "date_is_late": "The date is too late! Current: {0}, Maximum: {1}",
        "invalid_email": "Invalid e-mail address!",
        "invalid_uRL": "Invalid URL!",
        "invalid_card": "Invalid card format!",
        "invalid_card_number": "Invalid card number!",
        "invalid_text_contain_number": "Invalid text! Cannot contains numbers or special characters",
        "invalid_text_contain_spec": "Invalid text! Cannot contains special characters",
        "transmitter_not_used": "At least one transmitter has to be used.",
        "liters_per_hour": "liters/hour",
        "liters_per_second": "liters/second",
        "suspicious_consumption_fluctuation": "Suspicious consumption fluctuation",
        "suspicious_consumption_fluctuation_desc": "Evaluated on the hour by comparison with historical data. Unit reverse flow (−1 to −2 L) is ignored by default.",
        "alert_on_negative_consumption": "Also warn on negative consumption",
        "consumption_last_hour": "Consumption for the last hour",
        "consumption_last_hour_desc": "Evaluated on the hour",
        "add_alarm": "Add alarm",
        "current_flow": "Current flow",
        "current_flow_desc": "Evaluated with each data transmission (5/20 minutes). Eg. broken plumbing.",
        "water_consumption_time_interval": "Sum of consumption in a given time interval",
        "water_consumption_time_interval_desc": "Eg. detecting leaking plumbing during the night",
        "alarm_data_source": "Data source",
        "alarm_source_auto": "Automatic: control meter, otherwise structure sum",
        "alarm_source_control": "Control meter",
        "alarm_source_structure": "Sum of child structure",
        "continuous_water_flow": "Continuous water flow",
        "continuous_water_flow_desc": "Eg. full bathtub (recommended onluy with 5 minute transmission intervals)",
        "between": "between",
        "and": "and",
        "alarms_active": "Alarms are active. No suspicious events have been detected yet.",
        "alarms_inactive": "No alarms set yet. Add an alarm to any building or apartment by clicking this button",
        "battery_status": "Battery status",
        "archive": "Archive",
        "archived": "Archived",
        "archive_all": "Archive all",
        "water_blue": "Blue wire",
        "water_red": "Red wire",
        "all_alarms": "Show all alerts",
        "dashboard_alarms": "List of all alarms",
        "previous": "Previous",
        "next": "Next",
        "page_of": "Page {page} / {pages} ({total})",
        "watermeter_label_red": "Water meter ID (Red wire)",
        "watermeter_label_blue": "Water meter ID (Blue wire)",
        "advanced_settings": "Advanced settings",
        "organization": "Organization",
        "download": "Download",
        "count_physical": "Count",
        "count_total": "Total consumption",
        "count_reverse": "Back flow",
        "watermeter_label": "Water meter ID",
        "powermeter_label": "Electricity meter ID",
        "heatmeter_label": "Meter type",
        "split_bill_heading": "Split bill",
        "split_bill_verb": "Split bill of",
        "split_bill_for": "for",
        "split_bill_from": "from",
        "split_bill_to": "to",
        "split_bill_in": "in",
        "split_amount": "Amount",
        "start_count": "Start count",
        "end_count": "End count",
        "consumption": "Consumption",
        "currency": "Currency",
        "all_buildings": "All buildings",
        "forgot_password": "Forgot password",
        "reset_password": "Reset password",
        "new_password": "New password",
        "new_password_again": "New password again",
        "set_new_password": "Set new password",
        "password_too_short": "Password is too short (< 8 characters)",
        "passwords_not_match": "Passwords do not match",
        "seal_number": "Seal number",
        "help": "Help",
        "help_link": "https://wateradmin.com/how-it-works/web-app",
        "water": "Water",
        "electricity": "Electricity",
        "gas": "Gas",
        "heat": "Heat",
        "valves": "Valves",
        "water_valves": "Water Valves",
        "valve": "Valve",
        "add_valve": "Add valve",
        "dashboard_valves": "List of valves",
        "homebase": "Homebase",
        "dashboard_valves_explanation": "Valves are added here automatically as soon as they are paired with a homebase that is already added to the app. <a href='https://wateradmin.com/how-it-works/smart-water-valve' target='blank'>More information on smart water valves</a>.",
        "serial_number_valve": "Serial number of valve",
        "status": "Status",
        "limit_current_flow": "Limit for current flow",
        "limit_continuous_consumption": "Limit for continuous consumption",
        "limit_dripping": "Limit for dripping",
        "limit_consumption_in_time": "Limit for consumption in a time interval",
        "valve_closed": "Closed",
        "valve_closed_neutral": "Closed",
        "valve_closing": "Closing",
        "valve_open": "Open",
        "valve_open_neutral": "Open",
        "valve_opening": "Opening",
        "valve_half_open": "Half-open",
        "valve_half_open_neutral": "Half-open",
        "valve_disconnected": "Disconnected",
        "valve_state_unknown": "Unknown state",
        "last_known_state": "Last known state",
        "valve_status_may_be_stale": "The current valve status could not be loaded. The displayed status may be a few minutes old.",
        "valve_setting_resending": "Sending setting “{setting}” ({value}) for valve {valve} via homebase {homebase}.",
        "valve_setting_resending_generic": "Sending settings for valve {valve} via homebase {homebase}.",
        "valve_setting_applied": "Settings for valve {valve} were saved successfully.",
        "no_signal": "No signal",
        "hours": "hours",
        "minutes": "min",
        "close_valve": "Close valve",
        "open_valve": "Open valve",
        "liters_in": "liters in",
        "liters_after_number": "liters",
        "dripping_unit": "consecuitive hours with any consumption",
        "close_water_automatically": "Close water automatically",
        "when_the_current_flow": "When the current flow exceeds",
        "when_continuous_consumption_exceeds": "When continuous consumption exceeds",
        "after": "If in ",
        "consecutive_hours_with_any_consumption": "hours there is not a single hour with no consumption",
        "when_the_total_consumption": "When total consumption exceeds",
        "settings": "Settings",
        "example": "Example",
        "current_flow_example": "Cracked pipe",
        "continuous_consumption_example": "Bathtub overflow",
        "dripping_example": "Leaking toilet",
        "total_consumption_example": "Limiting daily consumption from a well",
        "check_maximum": "Check maximum",
        "maximum_until_now": "Maximum until now",
        "less_then": "less then",
        "greater_then": "greater then",
        "equals": "=",
        "passwords_not_match": "Passwords do not match",
        "billing_period": "Billing period",
        "billing_total_consumption_apartments": "Total consumption measured in apartments",
        "billing_total_consumption_control_meter": "Total consumption measured by control meter",
        "billing_consumption_difference": "Difference in measurements",
        "billing_price_per": "Price for water",
        "billing_leftover": "Unbilled amount",
        "tenants": "Number of persons",
        "persons": "Persons",
        "total_consumption_per_person": "Total Consumption per Person",
        "daily_consumption_per_person": "Daily Consumption per Person",
        "and_for_heating_water": "and for heating water",
        "cost_of_consumption": "Cost of consumption",
        "cost_of_heating_water": "Cost of heating water",
        "total_cost": "Total cost",
        "from": "From",
        "to": "To",
        "download_transmitter_data": "Download transmitter data",
        "alarm_reports": "Alarms",
        "liter": "liter",
        "currentDateTime": "Current time",
        "difference_from_validation_transmitter": "Difference from validation transmitter",
        "validation_transmitter_not_available": "Validation transmitter not available",
        "include_validation_meter_data": "Include validation meter data",
        "watts": "watts",
        "power": "kWh",
        "lowest_consumption_in_a_given_row": "lowest consumption in a given row",
        "highest_consumption_in_a_given_row": "highest consumption in a given row",
        "reset": "Reset",
        "water_meters": "Water meters",
        "electricity_meters": "Electricity meters",
        "electricity_meter": "Electricity meter",
        "gas_meters": "Gas Meters",
        "gas_meter": "Gas Meter",
        "heat_meters": "Heat Meters",
        "heat_meter": "Heat Meter",
        "measurement": "Measurement",
        "water_type": "Type of water",
        "pulse_count": "1 pulse equals",
        "pulse_count_kwh": "1 kWh equal",
        "pulse_count_l": "1 pulse equal",
        "pulses": "pulses",
        "transmitter_id": "Transmitter",
        "signal": "Signal",
        "valve_email_warning": "Notification of valve closure with link for quick opening",
        "internet_required": "requires internet connection",
        "valve_email_warning_2": "For security reasons, valve closure notifications cannot be deactivated",
        "add": "Add",
        "transmitter_battery_alarm": "Low-battery notifications for transmitters below are automatically sent to",
        "m3": "m3",
        "heat_unit": "unit | units",
        "heat_units": "units",
        "new_building": "A new building will be created",
        "new_unit": "A new apartment/office will be created",
        "data_loaded": "Updated",
        "reload": "Reload"
    }
}
